module.exports = {

    createCookie: function( name, value, seconds ) {
        var expires = '';
        if ( seconds ) {
            var date = new Date();
            date.setTime( date.getTime()+( seconds * 1000 ) );
            expires = '; expires='+date.toGMTString();
        }
        document.cookie = name+'='+value+expires+'; path=/';
    },

    readCookie: function( name ) {
        var nameEQ = name + '=';
        var ca = document.cookie.split( ';' );
        for( var i=0; i < ca.length; i++ ) {
            var c = ca[ i ];
            while ( c.charAt( 0 )==' ' ) c = c.substring( 1, c.length );
            if ( c.indexOf( nameEQ ) == 0 ) return c.substring( nameEQ.length, c.length );
        }
        return null;
    },

    eraseCookie: function( name ) {
        this.createCookie( name, '', -1 );
    }
};

// source: http://www.quirksmode.org/js/cookies.html?


//////////////////
// WEBPACK FOOTER
// ./node_modules/standard-vote/app/scripts/util/cookie.js
// module id = 97
// module chunks = 0